// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchResetFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/SimpleQuoteForm/ResetFieldValues",
    });
};

export const chain = [DispatchResetFieldValues];

const resetFieldValues = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetFieldValues");

export default resetFieldValues;
